import { render, staticRenderFns } from "./NlpLinkedin.vue?vue&type=template&id=61ece0b0"
import script from "./NlpLinkedin.vue?vue&type=script&lang=js"
export * from "./NlpLinkedin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports